import { SvgIcon, SvgIconProps } from "@mui/material";
import * as React from "react";

interface IconProps extends SvgIconProps {}

const DeleteOutlinedIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M16.1613 4.67773V17.55C16.1613 18.0377 15.9675 18.5054 15.6227 18.8502C15.2778 19.1951 14.8101 19.3888 14.3224 19.3888H5.12795C4.64025 19.3888 4.17252 19.1951 3.82766 18.8502C3.4828 18.5054 3.28906 18.0377 3.28906 17.55V4.67773"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.20093 4.65458C6.20093 4.16687 6.39345 1.88346 6.73613 1.5386C7.07881 1.19374 7.54359 1 8.02822 1H11.6828C12.1674 1 12.6322 1.19374 12.9749 1.5386C13.3176 1.88346 13.5101 4.16687 13.5101 4.65458"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.4502 4.67773H3.28908H18.0002"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.88574 9.27502V14.7917"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5625 9.2749V14.7916"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default DeleteOutlinedIcon;
